export default "/walletConnect.dd83a0dbecda64e2e63ee10201fb9f85.png";